export default __webpack_public_path__ + "static/media/Book-Antiqua.2abae92f.ttf";